/** @format */
import { useAppContext } from '../../store/store.app';
import PageSpinner from '../Molecules/Spinner/PageSpinner';

const UserInfoGate = ({ children }) => {
  const {
    appStore: { userInfo },
  } = useAppContext();

  if (!userInfo) {
    return <PageSpinner />;
  }
  return children;
};

export default UserInfoGate;
